<template>
    <div
        id="menu"
        uk-offcanvas="overlay: true; flip: true;"
    >
        <div class="uk-offcanvas-bar uk-flex uk-flex-column uk-flex-between">
            <div
                class="menu-content"
            >
                <ul class="uk-nav uk-nav-default">
                    <router-link
                        v-if="canUserAccessPayments"
                        tag="li"
                        to="/dashboard"
                        class="uk-parent"
                        active-class="uk-active"
                    >
                        <a>Dashboard</a>
                    </router-link>
                    <router-link
                        v-if="canUserAccessPayments"
                        tag="li"
                        to="/create"
                        class="uk-parent"
                        active-class="uk-active"
                    >
                        <a>New payment</a>
                    </router-link>
                    <router-link
                        v-if="canUserAccessPayments && isUserAdmin"
                        tag="li"
                        to="/report"
                        class="uk-parent"
                        active-class="uk-active"
                    >
                        <a>Report</a>
                    </router-link>
                    <router-link
                        v-if="canUserAccessRefunds"
                        tag="li"
                        to="/refund-requests"
                        class="uk-parent"
                        active-class="uk-active"
                    >
                        <a>Refund Requests</a>
                    </router-link>
                    <router-link
                        v-if="canUserAccessSettings"
                        tag="li"
                        to="/settings"
                        class="uk-parent"
                        active-class="uk-active"
                    >
                        <a>Settings</a>
                    </router-link>
                    <ul class="uk-nav-default uk-nav-parent-icon" uk-nav>
                        <li class="uk-parent">
                            <a href="#">Guides</a>
                            <ul class="uk-nav-sub">
                                <li><a href="#" @click="goToUsersGuide">Users</a></li>
                                <li><a href="#" @click="goToAdminsGuide">Admins</a></li>
                                <li v-if="canUserAccessRefunds">
                                    <a href="#" @click="goToRefundsForAccountsTeamGuide">Refunds for Accounts Team</a>
                                </li>
                                <li><a href="#" @click="goToTenderDepositGuide">Tender Deposit</a></li>
                            </ul>
                        </li>
                    </ul>
                </ul>
            </div>
            <button
                ref="closeButton"
                class="uk-offcanvas-close"
                type="button"
                uk-close
            />
            <sign-out
                redirect-route-name="Logout"
                @onLogout="onLogout"
            >
                <template slot-scope="scope">
                    <div>
                        <div
                            v-if="user != null"
                        >
                            {{ loggedInAsMessage }} <br>
                            <a
                                @click="scope.logout"
                            >Log Out</a>
                        </div>
                    </div>
                </template>
            </sign-out>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'
const SignOut = () => import('@strangeanimals/common-vue-components/src/components/forms/SignOut')

export default {
    components: { SignOut },
    computed: {
        ...mapGetters({
            user: 'user',
            isUserAdmin: 'isUserAdmin',
            canUserAccessPayments: 'canUserAccessPayments',
            canUserAccessRefunds: 'canUserAccessRefunds',
            canUserAccessSettings: 'canUserAccessSettings',
        }),
        loggedInAsMessage() {
            let msg = 'Logged in as';
            msg = this.user.firstName ? msg + ' ' + this.user.firstName : msg;
            msg = this.user.surname ? msg + ' ' + this.user.surname : msg;
            return msg;
        }
    },
    methods: {
        onLogout() {
            const closeBtn = this.$refs.closeButton;
            closeBtn.click();
        },
        goToUsersGuide() {
            window.open('https://simonds.atlassian.net/servicedesk/customer/portal/4/article/48005121', '_blank');
        },
        goToAdminsGuide() {
            window.open('https://simonds.atlassian.net/servicedesk/customer/portal/4/article/48070657', '_blank');
        },
        goToRefundsForAccountsTeamGuide() {
            window.open('https://simonds.atlassian.net/servicedesk/customer/portal/4/article/1527742468', '_blank');
        },
        goToTenderDepositGuide() {
            window.open('https://simonds.atlassian.net/servicedesk/customer/portal/4/article/1915781121', '_blank');
        }
    }
}
</script>
